import React from 'react';
import { CollapseDrawerProvider } from 'main/contexts/CollapseDrawerContext';
import { HashContextProvider } from 'main/contexts/HashContext';
import { SessionProvider } from 'main/contexts/SessionContext';
import { PartnerProvider } from 'main/contexts/PartnerContext';

const AppProviders = ({ children }) => {
  return (
    <CollapseDrawerProvider>
      <PartnerProvider>
        <HashContextProvider>
          <SessionProvider>
            {children}
          </SessionProvider>
        </HashContextProvider>
      </PartnerProvider>
    </CollapseDrawerProvider>
  );
};

export default AppProviders;
